import {createSelector} from "reselect";
import {AdminsState} from "./types";
import { RootState } from "..";


export const rootSelector: (state: RootState) => AdminsState = (state: RootState) => state.admins;

export const adminsSelector = createSelector(rootSelector, (items) => items.admins);
export const adminSelector = (adminId : string) => createSelector(rootSelector, (items) => items.admins.find(admin => admin._id === adminId));
